type GetTableHeaderOptionsProps = {
  isSortable: boolean;
  onSort: (direction: 'asc' | 'desc') => void;
};

export const getTableHeaderOptions = ({
  isSortable,
  onSort
}: GetTableHeaderOptionsProps) => {
  const options = [];

  if (isSortable) {
    options.push(
      { label: 'Sort ascending', onClick: () => onSort('asc') },
      { label: 'Sort descending', onClick: () => onSort('desc') }
    );
  }

  return options;
};
